<div class="file-upload" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" [class.dragging]="isDragging">
  <label>
    <i-tabler name="cloud-upload"></i-tabler>
    <span class="title">{{title}}</span>
    <p class="text">{{text}}</p>
    <input type="file" accept="application/pdf,image/png,image/jpg,image/jpeg,image/webp" (change)="onFilesSelected($event)" multiple hidden />
  </label>

  <!--<div class="file-list" *ngIf="showFilePreview && uploadedFiles.length > 0">
    <ul>
      <li *ngFor="let file of uploadedFiles">
        <span>{{ file.name }}</span>
        <button (click)="removeFile(file)" class="delete-button">
          <i class="fas fa-times"></i>
        </button>
      </li>
    </ul>
  </div>-->
</div>